import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import useTranslation from '@/utils/hooks/translation/useTranslation';
// Hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

import PropTypes from 'prop-types';

import { getSortOptions } from '@/lib/posts/postSortOptions';
// Lib
import { INSTAGRAM } from '@/lib/socialProfile';

import Select from '@/components/base/Select';
// Components

const SelectSortByButton = ({ selected }) => {
    return (
        <Select.Button sizeStyle="sm" baseStyle="noBorder">
            <span className="block truncate text-xs text-icoBlack dark:text-white">
                {selected?.label ?? selected?.value}
            </span>
        </Select.Button>
    );
};

const SelectSortBy = ({ setRequestParams, postType }) => {
    const { t } = useTranslation('commons');
    const { activeSocialProfile } = useActiveSocialProfile();
    const sortOptions = getSortOptions(postType, t);
    const router = useRouter();
    const { deleteQuery } = useRouterQuery();
    const { column, order } = router.query;
    const [activeSort, setActiveSort] = useState(
        column && order
            ? sortOptions[activeSocialProfile?.social_network_type ?? INSTAGRAM]?.filter(
                  (element) => element.value === column && element.order === order
              )?.[0]
            : sortOptions[activeSocialProfile?.social_network_type ?? INSTAGRAM]?.[0]
    );

    useEffect(() => {
        if (column && order) {
            const newUrl = deleteQuery(['column', 'order']);
            router.replace(newUrl);
        }
        setRequestParams((prevState) => ({
            ...prevState,
            sort: {
                column: activeSort.value,
                order: activeSort.order
            }
        }));
    }, [activeSort, setRequestParams]);

    return (
        <Select
            selected={
                sortOptions[activeSocialProfile?.social_network_type ?? INSTAGRAM]?.filter(
                    (item) => item.value === activeSort.value && item.order === activeSort.order
                )[0]
            }
            setSelected={setActiveSort}
            options={sortOptions[activeSocialProfile?.social_network_type ?? INSTAGRAM]}
            noBorder
            button={<SelectSortByButton />}
        />
    );
};

SelectSortBy.propTypes = {
    setRequestParams: PropTypes.func,
    postType: PropTypes.string
};

export default SelectSortBy;
